module.exports = __webpack_public_path__ + "img/smart-scan-char-2.cf6e297b.png";